export default "__VITE_ASSET__Dr4bdtmZ__"